import {SET_CURRENT_LANGUAGE, RECEIVE_DICTIONARY} from '../constants/ActionTypes';

const initialState = {
    currentLanguage: 'pl',
    availableLanguages: [
        'pl',
        'en'
    ],
    dictionary: {}
};

export default function language(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_LANGUAGE:
            return {
                ...state,
                currentLanguage: action.lang
            };
        case RECEIVE_DICTIONARY:
            return {
                ...state,
                dictionary: action.data
            };
        default:
          return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/language.js